
const data = [
    {
        id: 1,
        name: 'Pear',
        bodyShape: 'You have a Pear Body Shape!',
        characteristics: {
            main: 'Hips are wider than shoulders',
            secondary: 'Small bust and well defined waist',
            additional: 'Carries extra weight in hips and thighs',

        },
        isPear: false,
      },
      {
        id: 2,
        name: 'Apple',
        bodyShape: 'You have an Apple Body Shape!',
        characteristics: {
            main: 'Larger bust with less defined waist',
            secondary: 'Slim legs and narrow hips',
            additional: 'Carries weight in the midsection',
        },
        isApple: false,
      },
      {
        id: 3,
        name: 'Triangle',
        bodyShape: 'You have an Inverted Triangle Body Shape!',
        characteristics: {
            main: 'Shoulders are wider than hips',
            secondary: 'Small to large bust with somewhat defined waist',
            additional: 'Carries weight in upper body',
        },
        
      },
      {
        id: 4,
        name: 'Rectangle',
        bodyShape: 'You have a Rectangle Body Shape!',
        characteristics: {
            main: 'Hips, waist, and shoulders are similar measurements',
            secondary: 'Slim legs with a less defined waist',
            additional: 'Carries weight evenly across hips, waist, and shoulders',
        },
        isRectangle: false,
      },
      {
        id: 5,
        name: 'Hourglass',
        bodyShape: 'You have an Hourglass Body Shape!',
        characteristics: {
            main: 'Hips and shoulders roughly the same measurements',
            secondary: 'Small defined waist with larger bust',
            additional: 'Carries weight in hips, thighs, and bust',
        },
        isHourglass: false,
      }

]

export default data